module.exports = __webpack_public_path__ + "static/img/sprite-vlieg-left.3f6de40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/sprite-vlieg-left.png
// module id = 685
// module chunks = 64